import axiosInstance from '../../../utils/axiosConfig'
import { mobileBackendUrl } from '../../../env'
import type { HarvestingPlanType } from '../types/summary.types'
import type { PowerPerformanceForms } from '../../../types/mutual-fund-detail.types'

export interface TaxHarvestingPlanFundDetail {
  isin: string
  fundName: string
  fundCategory: string
  fundNature: string
  bookGain: number
  saveTax: number
  rank: number
  fundLogo: string
  fundPerformance: `${PowerPerformanceForms}` | null
}

export interface TaxHarvestingPlanDetailResponse {
  harvestingType: HarvestingPlanType
  totalPlanCount: number
  totalFundCount: number
  planAvailable: boolean
  totalGain: number
  harvestingTypeResponse: {
    netEquity: number
    taxPercentage: number
    unrealisedAmount: number
    taxLiability: number
  }
  /** Funds that form the primary plan we show on the page */
  eligiblePlanDetails: TaxHarvestingPlanFundDetail[]
  /** Additional funds only shown when user taps "View all eligible funds" */
  remainingPlanDetails: TaxHarvestingPlanFundDetail[]
}

export async function fetchTaxHarvestingPlanDetail(
  harvestingPlanType: HarvestingPlanType
): Promise<TaxHarvestingPlanDetailResponse> {
  const response = await axiosInstance.get<TaxHarvestingPlanDetailResponse>(
    `${mobileBackendUrl}/v2/tax-harvesting/plan-detail`,
    {
      params: { harvestingPlanType }
    }
  )

  if (!response?.data) {
    throw new Error('Failed to fetch tax harvesting plan detail')
  }

  return response.data
}
